import './lib/polyfills';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, MemoryRouter } from 'react-router-dom';
import './index.css';
import '@/i18n';
import { App } from './App';
import { detectAndroidApp } from './lib/androidApp';
import { reportError } from './lib/errors';
import { graphics } from './lib/graphics';
import { initIosViewport } from './lib/iosViewport';
import { initNativeApp, nativeApp, removeBootSplash } from './lib/native';
import { platform } from './lib/platform';

// Игра открыта из Android-приложения — запомнить версию APK (для окна «Вышло обновление»)
detectAndroidApp();
// Игра внутри APK: внешние ссылки — в браузер, кнопка «Назад» Android
initNativeApp();
initIosViewport();
// Графика: при первом запуске оценить устройство (полная или экономная), дальше — сохранённый выбор
graphics();

// Яндекс Игры: страница игры принадлежит Яндексу — адрес не меняем, маршруты живут в памяти
const Router = platform === 'yandex' ? MemoryRouter : BrowserRouter;

window.addEventListener('error', (e) =>
  reportError(e.message, e.error instanceof Error ? e.error.stack : undefined),
);
window.addEventListener('unhandledrejection', (e) =>
  reportError(String(e.reason), e.reason instanceof Error ? e.reason.stack : undefined),
);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Router>
      <App />
    </Router>
  </StrictMode>,
);

// На сайте стартовый фон сменяет сама страница. В приложении его снимает первый настоящий экран
// (вход или загрузка игры), а таймер лишь страхует редкие маршруты.
window.setTimeout(
  () => {
    if (!location.pathname.startsWith('/game')) removeBootSplash();
  },
  nativeApp ? 20_000 : 0,
);
// Что бы ни случилось с экраном загрузки, фон не должен навсегда закрыть игру
window.setTimeout(removeBootSplash, 40_000);
